let PopupMenu = function (container) {
    this.container = $(container).data('popup', this);
    this.popup = $('.popup-menu', this.container);
    this.closeButton = $('.popup-menu-close', this.container);
    this.showButton = $('.popup-menu-show', this.container);

    this.closeButton.on('click', this.close.bind(this))
    this.showButton.on('click', this.show.bind(this))
}

PopupMenu.prototype.show = function () {
    if (!this.container.data('disabled')) {
        this.popup.show();
    }
};

PopupMenu.prototype.close = function () {
    this.popup.hide();
};

$(function () {
    let popups = [];
    $('.popup-menu-wrap').each(function () {
        popups.push(new PopupMenu($(this)));
    });
    $(document).on('click', '[data-popup]', function (e) {
        let link = $(e.currentTarget),
            popupId = link.data('popup'),
            popup = $('#' + popupId);
        if (popup.length > 0) {
            popup.data('popup').show();
        }
    });

    $(document).on('mouseup.popupMenu', function (e) {
        $(popups).each(function (index, popup) {
            if (!popup.popup.is(e.target) && popup.popup.has(e.target).length === 0) {
                popup.close();
            }
        });
    });
});